import { motion } from "framer-motion";
import classes from "./IndividualQuestion.module.scss";
import clsx from "clsx";
import { COLORS, CONTENT_TYPE, NAME_SOUND_HOVER, useGameSounds } from "@educaplay/core";
import { QUESTION_TYPE } from "../../../../../utils/constants";
import LetterContainer from "../../LetterContainer";
import { AudioComponentControl } from "@educaplay/core/components/AudioComponentControl";


const childVariants = {
    hidden: {
        opacity: 0,
        y: "100%",
    },
    show: {
        opacity: 1,
        y: 0
    }
}

export default function IndividualQuestion(props) {
    const { index, answer, isSelected, type, previousAnswers, animationComplete, onChangeHandler, onClickImageHandler, sizeClass } = props;
    const gameSound = useGameSounds();
    
    return (
        <motion.div
            className={clsx(classes.individualQuestion, classes[answer.className])}
            variants={childVariants}
            onMouseEnter={() => gameSound.play(NAME_SOUND_HOVER)}
        >
            <label className={classes.clickableZone} style={{ pointerEvents: previousAnswers != null ? "none" : "auto" }}>
                <div className={clsx(classes.contentContainer, isSelected && classes[`selected`], classes[answer.className])}>
                    <input
                        key={isSelected}
                        type="checkbox"
                        value={answer.id}
                        name='options'
                        onChange={onChangeHandler}
                        className={clsx(classes.inputposition, type === QUESTION_TYPE.SingleQuestion && classes.invisibleInput, classes[answer.className])}
                        checked={isSelected}
                        disabled={!animationComplete}
                    />
                    <LetterContainer index={index} />
                    {answer.type && (
                        <div className={classes.multimediaContainer}>
                            {answer.type === CONTENT_TYPE.IMAGE && (
                                <div className={clsx(classes.sourceMedia, classes.borderimg)}>
                                    <img
                                        src={answer.source}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onClickImageHandler();
                                        }}
                                    />
                                </div>
                            )}
                            {answer.type === CONTENT_TYPE.AUDIO && (
                                <div className={classes.sourceMedia}>
                                    <AudioComponentControl source={answer.source} color={COLORS.primary} className={classes.audioComponent} />
                                </div>
                            )}
                        </div>
                    )}
                    {answer.answer && (
                        <div className={clsx(classes.textContainer, classes.scrollbar, classes[sizeClass])}>
                            {answer.answer}
                        </div>
                    )}
                </div>
            </label>
        </motion.div>
    )
}